import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<
  IVisaPrepForm,
  | 'residentialAddressStartDate'
  | 'homeOwnershipStatus'
  | 'homeOwnershipStatusOther'
  | 'hasDifferentContactDetails'
  | 'diffContactAddress'
  | 'diffContactCity'
  | 'diffContactPostcode'
  | 'diffContactCountry'
>;

type Params = Fields;

export function getPageStatus({
  residentialAddressStartDate,
  homeOwnershipStatus,
  homeOwnershipStatusOther,
  hasDifferentContactDetails,
  diffContactAddress,
  diffContactCity,
  diffContactPostcode,
  diffContactCountry
}: Params): { complete: boolean } {
  let complete = true;
  if (
    residentialAddressStartDate === '' ||
    homeOwnershipStatus === '' ||
    (homeOwnershipStatus === 'Other' && homeOwnershipStatusOther === '') ||
    hasDifferentContactDetails === undefined ||
    (hasDifferentContactDetails && (diffContactAddress === '' || diffContactCity === '' || diffContactCountry === ''))
  ) {
    complete = false;
  }

  return { complete };
}
